import { EmailStatus } from "@pulse/pulse-rpcs/lib/types/emailStatus";
import { ChipProps } from "@surya-digital/leo-reactjs-material-ui";
import { TFunction } from "i18next";

export const getEmailStatusChipProps = (
  t: TFunction,
  status: EmailStatus.EmailStatus,
): ChipProps => {
  switch (status) {
    case EmailStatus.EmailStatus.QUEUED:
      return {
        label: t("emailCycles.queued"),
        color: "neutral",
      };
    case EmailStatus.EmailStatus.SENT:
      return {
        label: t("emailCycles.sent"),
        color: "primarySubtle",
      };
    case EmailStatus.EmailStatus.DELIVERED:
      return {
        label: t("emailCycles.delivered"),
        color: "blueSubtle",
      };
    case EmailStatus.EmailStatus.VIEWED:
      return {
        label: t("emailCycles.read"),
        color: "greenSubtle",
      };
    case EmailStatus.EmailStatus.UNSENT:
    case EmailStatus.EmailStatus.STOPPED:
      return {
        label: t("emailCycles.unsent"),
        color: "orangeSubtle",
      };
    case EmailStatus.EmailStatus.BOUNCED:
      return {
        label: t("emailCycles.bounced"),
        color: "redSubtle",
      };
    case EmailStatus.EmailStatus.COMPLAINT:
      return {
        label: t("emailCycles.complaint"),
        color: "redSubtle",
      };
    default:
      return status satisfies never;
  }
};
